import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios'; // We will use axios for making API requests
import { API_URL, MOBILE_WEB_URL } from '../../constants/api';
import { updateFavicon } from '../../utlis';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { notification } from 'antd';
import { decodeToken } from '../../utils/TokenUtils';
import socket from '../../utils/socket';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [company, setCompany] = useState([]);

  const [error, setError] = useState('');
  const navigate = useNavigate(); // Hook to navigate to other routes
  const { loginRoute } = useParams();

  const [deviceFingerprint, setDeviceFingerprint] = useState(null);

  // try {
  //   console.log('in try');

  //   console.log('in token');

  //   let system_name = 'Kaafiye Technology Center';
  //   let email = 'abdihamidkashi@gmail.com';

  //   // Connect and join the user's room
  //   socket.emit('join', { email, system_name });
  //   console.log('emited');
  // } catch (error) {
  //   console.log('in catch');

  //   console.log('joining socket:', error.message);
  // }

  // if (socket) {
  //   socket.disconnect(); // Disconnect socket on logout
  //   console.log('User logged out and socket disconnected');
  // }
  useEffect(() => {
    // Initialize FingerprintJS and get the device fingerprint
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setDeviceFingerprint(result.visitorId); // unique identifier for this device
    };

    loadFingerprint();
  }, []);
  useEffect(() => {
    // Check if the token exists

    const fetchCompany = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/users/get-company/${loginRoute}`
        );

        //console.log(response.data.company);
        setCompany(response.data.company[0]);
        const company = response.data.company[0];

        let language = localStorage.getItem('language') || company.default_lang; // 'company's default lang' is the default language

        // Optionally, you can store it back in localStorage if it's not set
        if (!localStorage.getItem('language')) {
          localStorage.setItem('language', language);
        }

        if (company?.name) {
          document.title = company.name;
        }

        // Set Favicon
        if (company?.logo) {
          const iconUrl = `${API_URL}/${company.logo}`;
          updateFavicon(iconUrl); // Replace with your image URL
        }
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        notification.error({
          message: `Error ${error.response?.status}: ${error.response.data.message || 'Unknown error'}`,
        });
        setError(error.response.data.message);
      }
    };
    fetchCompany();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple validation for demo purposes
    if (!email || !password) {
      setError('Both fields are required.');
      return;
    }

    const url = `${API_URL}/api/users/login/${loginRoute}`;
    const deviceToken = localStorage.getItem('trusted_device');
    try {
      // API call to login
      const response = await axios.post(
        url,
        {
          email,
          password,
          deviceFingerprint,
        },
        {
          headers: {
            Authorization: deviceToken ? `Bearer ${deviceToken}` : '',
          },
        }
      );

      // console.log('2FA:', response.data);
      if (response.data.success === 0) {
        setError(response.data.message);
      } else {
        // If login is successful, the server will return a JWT token
        const token = response.data.token;
        console.log('toke got');
        const dashboard = decodeToken(token, 'dashboardPage');

        try {
          console.log('in try');

          if (token) {
            console.log('in token');

            let system_name = decodeToken(token, 'companyName');
            let email = decodeToken(token, 'email') || '';

            console.log('system_name:', system_name, 'email:', email);
            // Connect and join the user's room
            socket.emit('join', { email, system_name });
            console.log('emited');
          }
        } catch (error) {
          console.log('in catch');

          console.log('joining socket:', error.message);
        }

        // Store the JWT token in localStorage (or sessionStorage)
        localStorage.setItem('authToken', token);

        console.log('response.data:', response.data);
        if (
          response.data.is2FaVerified ||
          (!response.data.is2FAForce && !response.data.is2FA)
        ) {
          // Redirect to the dashboard
          navigate(dashboard);
        } else if (response.data.is2FAForce && !response.data.is2FA) {
          // console.log('is2FAForce:', response.data.is2FAForce);

          // Redirect to the dashboard
          navigate('/register-2fa');
        } else {
          navigate('/check-2fa');
        }
      }
    } catch (error) {
      // Handle error (e.g., invalid credentials)
      setError('Invalid email or password .');
    }
  };

  //console.log(company)
  const isMobileDevice =
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  if (isMobileDevice) {
    //console.log('MOBILE_WEB_URL:', MOBILE_WEB_URL);
    window.location.href = MOBILE_WEB_URL; // ✅ Full URL redirect
  }

  return (
    <div
      className="container-fluid min-vh-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundImage: `url(${API_URL}/${company.background_image})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div className="col-md-4 p-4 border rounded shadow-lg bg-light">
        {/* Company Logo */}
        <div className="text-center mb-4">
          {company.logo && (
            <img
              src={`${API_URL}/${company.logo}`}
              alt="Company Logo"
              style={{
                maxWidth: '100%',
                maxHeight: '100px',
                objectFit: 'contain',
              }}
            />
          )}
        </div>

        <h2 className="text-center mb-4">{company.name}</h2>
        <h2 className="text-center mb-4">{company.route_title}</h2>

        {error && <div className="alert alert-danger">{error}</div>}
        {company?.status === '0' && (
          <div className="alert alert-danger">
            {'System not works, please contact to KTC Finance office'}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email/Username/tell
            </label>
            <input
              type="text"
              className="form-control"
              id="email"
              placeholder="Enter your Email/Tell or Username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8} // example: minimum of 6 characters
            />
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <button type="submit" className="btn btn-primary">
              Login
            </button>
            <a
              href={`/forgot-password/${loginRoute}`}
              className="text-decoration-none"
            >
              Forgot Password?
            </a>
          </div>
        </form>

        <br />
        <center>
          <h5>
            Powered by Kaafiye Technology Center{' '}
            <a href="https://kaafiyetech.so" target="_blank" rel="noreferrer">
              KTC
            </a>
          </h5>
        </center>
      </div>
    </div>
  );
};

export default Login;
